export default "__VITE_ASSET__B6l1Kym7__"